import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import CloseIcon from '../../assets/CloseIcon'
import Card from '../Common/Card/Card'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import {
    CUSTOMER_FIELDS,
    ADDRESS_ENTRY_TYPE,
    ADDRESS_FIELDS,
    PAGE_CONST,
    PERMISSION_FEATURE,
    PERMISSION_SCREEN,
    PERMISSION_TYPE
} from '../../common/constant/page-constant'

import './ManageCustomer.scss'
import { addCustomerAlertAction } from '../../modules/actions/action'
import {
    addCustomerHelper,
    getCustomerHelper,
    getAllCustomersHelper,
    updateCustomerHelper
} from '../../helper/home-helper'
import {
    getDivisionsHelper,
    getDistrictsHelper,
    getPoliceStationsHelper,
    getPostOfficesHelper
} from '../../helper/address-helper'
import Alert from '../../components/Alert/Alert'
import {
    HEADER_CONFIG,
    HEADER_CONST
} from '../../common/constant/common-constant'
import MobileHeader from '../Common/Header/MobileHeader'
import { useNavigate } from 'react-router-dom'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import AddIcon from '../../assets/AddIcon'
import { convertToTitleCase } from '../../common/utils/appUtils'
import CustomMap from '../../components/CustomMap/CustomMap'
import EditIcon from '../../assets/EditIcon'

const ManageCustomer = props => {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()

    const [viewDrawer, setViewDrawer] = useState(false)
    const [open, setOpen] = useState(false)
    const [customerData, setCustomerData] = useState(undefined)
    const [manageCustomerData, setManageCustomerData] = useState(undefined)
    const [name, setName] = useState(undefined)
    const [mobileNumber, setMobileNumber] = useState(undefined)
    const [billingAddress, setBillingAddress] = useState(undefined)
    const [shippingAddress, setShippingAddress] = useState(undefined)
    const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
    const [addCustomerAlert, setAddCustomerAlert] = useState(false)
    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.CUSTOMERS,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () =>
            redirect(navigate, PAGE_CONST.HOME)
    })
    const [loginData, setLoginData] = useState({})
    const [permissions, setPermissions] = useState({})
    
    // Edit mode states
    const [isEditMode, setIsEditMode] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [showMapPopup, setShowMapPopup] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')
    const [alertType, setAlertType] = useState('success')

    // Address entry states
    const [addressEntryType, setAddressEntryType] = useState(ADDRESS_ENTRY_TYPE.MANUAL)
    const [divisions, setDivisions] = useState([])
    const [districts, setDistricts] = useState([])
    const [policeStations, setPoliceStations] = useState([])
    const [postOffices, setPostOffices] = useState([])
    const [addressLoading, setAddressLoading] = useState(false)

    useEffect(() => {
        let addCustomerAlert = props.alert?.addCustomerAlert
        setAddCustomerAlert(addCustomerAlert)
    }, [props.alert?.addCustomerAlert])

    useEffect(() => {
        getCustomerData()
    }, [])

    useEffect(() => {
        if (!open) {
            handleHeaderConfigUpdate(HEADER_CONST.CUSTOMERS, () =>
                redirect(navigate, PAGE_CONST.HOME)
            )
            return
        }

        handleHeaderConfigUpdate(
            isEditMode ? HEADER_CONST.EDIT_CUSTOMER : HEADER_CONST.ADD_CUSTOMERS, 
            () => handleDrawerToggle()
        )
    }, [open, isEditMode])

    useEffect(() => {
        setLoginData(props.loginData)

        if (props.loginData.permissions) {
            console.log(
                'props.loginData.permissions: ',
                props.loginData.permissions
            )

            let permission = props.loginData.permissions.filter(
                permission => permission.screen === PERMISSION_SCREEN.OTHER
            )[0]

            console.log('home screen permission: ', permission)
            if (permission) setPermissions(permission)
        }
    }, [props.loginData])

    // Load divisions on mount
    useEffect(() => {
        loadDivisions()
    }, [])

    const loadDivisions = () => {
        getDivisionsHelper()
            .then(res => {
                console.log('Divisions loaded:', res)
                setDivisions(res || [])
            })
            .catch(err => {
                console.log('Error loading divisions:', err)
                setDivisions([])
            })
    }

    const handleDivisionChange = (divisionId, divisionName) => {
        // Update customer data with selected division
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.DIVISION_ID]: divisionId,
            [ADDRESS_FIELDS.DIVISION_NAME]: divisionName,
            [ADDRESS_FIELDS.DISTRICT_ID]: '',
            [ADDRESS_FIELDS.DISTRICT_NAME]: '',
            [ADDRESS_FIELDS.POLICE_STATION_ID]: '',
            [ADDRESS_FIELDS.POLICE_STATION_NAME]: '',
            [ADDRESS_FIELDS.POST_OFFICE_ID]: '',
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: '',
            [ADDRESS_FIELDS.POST_CODE]: ''
        }))

        // Reset dependent dropdowns
        setDistricts([])
        setPoliceStations([])
        setPostOffices([])

        if (divisionId) {
            setAddressLoading(true)
            getDistrictsHelper(divisionId)
                .then(res => {
                    setDistricts(res)
                    setAddressLoading(false)
                })
                .catch(err => {
                    console.log('Error loading districts:', err)
                    setAddressLoading(false)
                })
        }
    }

    const handleDistrictChange = (districtId, districtName) => {
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.DISTRICT_ID]: districtId,
            [ADDRESS_FIELDS.DISTRICT_NAME]: districtName,
            [ADDRESS_FIELDS.POLICE_STATION_ID]: '',
            [ADDRESS_FIELDS.POLICE_STATION_NAME]: '',
            [ADDRESS_FIELDS.POST_OFFICE_ID]: '',
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: '',
            [ADDRESS_FIELDS.POST_CODE]: ''
        }))

        // Reset dependent dropdowns
        setPoliceStations([])
        setPostOffices([])

        if (districtId) {
            setAddressLoading(true)
            getPoliceStationsHelper(districtId)
                .then(res => {
                    setPoliceStations(res)
                    setAddressLoading(false)
                })
                .catch(err => {
                    console.log('Error loading police stations:', err)
                    setAddressLoading(false)
                })
        }
    }

    const handlePoliceStationChange = (policeStationId, policeStationName) => {
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.POLICE_STATION_ID]: policeStationId,
            [ADDRESS_FIELDS.POLICE_STATION_NAME]: policeStationName,
            [ADDRESS_FIELDS.POST_OFFICE_ID]: '',
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: '',
            [ADDRESS_FIELDS.POST_CODE]: ''
        }))

        // Reset dependent dropdown
        setPostOffices([])

        if (policeStationId) {
            setAddressLoading(true)
            getPostOfficesHelper(policeStationId)
                .then(res => {
                    setPostOffices(res)
                    setAddressLoading(false)
                })
                .catch(err => {
                    console.log('Error loading post offices:', err)
                    setAddressLoading(false)
                })
        }
    }

    const handlePostOfficeChange = (postOfficeId, postOfficeName, postCode) => {
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.POST_OFFICE_ID]: postOfficeId,
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: postOfficeName,
            [ADDRESS_FIELDS.POST_CODE]: postCode
        }))
    }

    const handleAddressEntryTypeChange = (type) => {
        setAddressEntryType(type)
        // Only update the address type, preserve existing address data
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.ADDRESS_TYPE]: type
        }))
        
        // If switching to manual entry and there's existing manual address data, reload cascade dropdowns
        if (type === ADDRESS_ENTRY_TYPE.MANUAL) {
            const divisionId = customerData?.[ADDRESS_FIELDS.DIVISION_ID]
            const districtId = customerData?.[ADDRESS_FIELDS.DISTRICT_ID]
            const policeStationId = customerData?.[ADDRESS_FIELDS.POLICE_STATION_ID]
            
            if (divisionId) {
                getDistrictsHelper(divisionId)
                    .then(res => setDistricts(res || []))
                    .catch(err => console.log('Error loading districts:', err))
            }
            if (districtId) {
                getPoliceStationsHelper(districtId)
                    .then(res => setPoliceStations(res || []))
                    .catch(err => console.log('Error loading police stations:', err))
            }
            if (policeStationId) {
                getPostOfficesHelper(policeStationId)
                    .then(res => setPostOffices(res || []))
                    .catch(err => console.log('Error loading post offices:', err))
            }
        }
    }

    const buildFullAddressString = () => {
        const parts = []
        if (customerData?.[ADDRESS_FIELDS.VILLAGE_HOUSE]) {
            parts.push(customerData[ADDRESS_FIELDS.VILLAGE_HOUSE])
        }
        if (customerData?.[ADDRESS_FIELDS.ROAD_BLOCK_SECTOR]) {
            parts.push(customerData[ADDRESS_FIELDS.ROAD_BLOCK_SECTOR])
        }
        if (customerData?.[ADDRESS_FIELDS.POST_OFFICE_NAME]) {
            parts.push(customerData[ADDRESS_FIELDS.POST_OFFICE_NAME])
        }
        if (customerData?.[ADDRESS_FIELDS.POLICE_STATION_NAME]) {
            parts.push(customerData[ADDRESS_FIELDS.POLICE_STATION_NAME])
        }
        if (customerData?.[ADDRESS_FIELDS.DISTRICT_NAME]) {
            parts.push(customerData[ADDRESS_FIELDS.DISTRICT_NAME])
        }
        if (customerData?.[ADDRESS_FIELDS.DIVISION_NAME]) {
            parts.push(customerData[ADDRESS_FIELDS.DIVISION_NAME])
        }
        if (customerData?.[ADDRESS_FIELDS.POST_CODE]) {
            parts.push(customerData[ADDRESS_FIELDS.POST_CODE])
        }
        return parts.join(', ')
    }

    const clearManualAddressFields = () => {
        setCustomerData(prev => ({
            ...prev,
            [ADDRESS_FIELDS.VILLAGE_HOUSE]: '',
            [ADDRESS_FIELDS.ROAD_BLOCK_SECTOR]: '',
            [ADDRESS_FIELDS.DIVISION_ID]: '',
            [ADDRESS_FIELDS.DIVISION_NAME]: '',
            [ADDRESS_FIELDS.DISTRICT_ID]: '',
            [ADDRESS_FIELDS.DISTRICT_NAME]: '',
            [ADDRESS_FIELDS.POLICE_STATION_ID]: '',
            [ADDRESS_FIELDS.POLICE_STATION_NAME]: '',
            [ADDRESS_FIELDS.POST_OFFICE_ID]: '',
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: '',
            [ADDRESS_FIELDS.POST_CODE]: ''
        }))
        setDistricts([])
        setPoliceStations([])
        setPostOffices([])
    }

    const clearGoogleMapsAddress = () => {
        setCustomerData(prev => ({
            ...prev,
            [CUSTOMER_FIELDS.BILLING_ADDRESS]: ''
        }))
    }

    const handleHeaderConfigUpdate = (title, handleBackFunc) => {
        setHeaderOptions({
            [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
            [HEADER_CONFIG.TITLE]: title,
            [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc()
        })
    }

    const getCustomerData = () => {
        getAllCustomersHelper()
            .then(res => {
                console.log('mc res: ', res)
                setManageCustomerData(res)
            })
            .catch(err => {
                console.log(err)
            })
    }

    const handleCustomerDetailUpdate = (key, value) => {
        setCustomerData({
            ...customerData,
            [key]: value
        })
    }

    const handleDrawerToggle = () => {
        setViewDrawer(!viewDrawer)
        setOpen(!open)
        if (open) {
            // Closing drawer - reset states
            setIsEditMode(false)
            setSelectedCustomer(null)
            resetDrawerData()
        }
    }

    const handleEditCustomer = (customer, e) => {
        e.stopPropagation()
        setSelectedCustomer(customer)

        // Determine address entry type from customer data
        // If customer has manual address fields (division_id), default to MANUAL
        // Otherwise default to GOOGLE
        const hasManualAddress = customer.division_id || customer.address_type === 'MANUAL'
        const entryType = customer.address_type || (hasManualAddress ? ADDRESS_ENTRY_TYPE.MANUAL : ADDRESS_ENTRY_TYPE.GOOGLE)
        setAddressEntryType(entryType)

        setCustomerData({
            [CUSTOMER_FIELDS.NAME]: customer.name,
            [CUSTOMER_FIELDS.PHONE_NUMBER]: customer.mobile_no,
            [CUSTOMER_FIELDS.BILLING_ADDRESS]: customer.billing_address,
            [CUSTOMER_FIELDS.SHIPPING_ADDRESS]: customer.shipping_address,
            // Manual address fields
            [ADDRESS_FIELDS.ADDRESS_TYPE]: entryType,
            [ADDRESS_FIELDS.VILLAGE_HOUSE]: customer.village_house || '',
            [ADDRESS_FIELDS.ROAD_BLOCK_SECTOR]: customer.road_block_sector || '',
            [ADDRESS_FIELDS.DIVISION_ID]: customer.division_id || '',
            [ADDRESS_FIELDS.DIVISION_NAME]: customer.division_name || '',
            [ADDRESS_FIELDS.DISTRICT_ID]: customer.district_id || '',
            [ADDRESS_FIELDS.DISTRICT_NAME]: customer.district_name || '',
            [ADDRESS_FIELDS.POLICE_STATION_ID]: customer.police_station_id || '',
            [ADDRESS_FIELDS.POLICE_STATION_NAME]: customer.police_station_name || '',
            [ADDRESS_FIELDS.POST_OFFICE_ID]: customer.post_office_id || '',
            [ADDRESS_FIELDS.POST_OFFICE_NAME]: customer.post_office_name || '',
            [ADDRESS_FIELDS.POST_CODE]: customer.post_code || ''
        })

        // Load cascade data if there's any manual address data (regardless of entry type)
        // This ensures data is available if user switches to manual entry mode
        if (customer.division_id) {
            getDistrictsHelper(customer.division_id)
                .then(res => setDistricts(res || []))
                .catch(err => console.log('Error loading districts:', err))

            if (customer.district_id) {
                getPoliceStationsHelper(customer.district_id)
                    .then(res => setPoliceStations(res || []))
                    .catch(err => console.log('Error loading police stations:', err))
            }

            if (customer.police_station_id) {
                getPostOfficesHelper(customer.police_station_id)
                    .then(res => setPostOffices(res || []))
                    .catch(err => console.log('Error loading post offices:', err))
            }
        }

        setIsEditMode(true)
        setOpen(true)
        setViewDrawer(true)
    }

    const handleCustomerCardClick = (customer) => {
        // Navigate to CustomerDetails page with customer data
        navigate(`/home/customer/${customer.id}`, { 
            state: { customer } 
        })
    }

    const checkValidation = () => {
        // Check basic fields
        if (!customerData?.[CUSTOMER_FIELDS.NAME] || !customerData?.[CUSTOMER_FIELDS.PHONE_NUMBER]) {
            return false
        }

        // Check address based on entry type
        if (addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL) {
            // For manual entry, check required address fields
            if (
                !customerData?.[ADDRESS_FIELDS.DIVISION_ID] ||
                !customerData?.[ADDRESS_FIELDS.DISTRICT_ID] ||
                !customerData?.[ADDRESS_FIELDS.POLICE_STATION_ID] ||
                !customerData?.[ADDRESS_FIELDS.POST_OFFICE_ID]
            ) {
                return false
            }
        } else {
            // For Google Maps entry, check billing address
            if (!customerData?.[CUSTOMER_FIELDS.BILLING_ADDRESS]) {
                return false
            }
        }

        return true
    }

    const handleSubmit = () => {
        if (!checkValidation()) {
            setIsFieldErrorVisible(true)
            return
        }

        setIsFieldErrorVisible(false)

        let data = { ...customerData }

        // Set address type
        data[ADDRESS_FIELDS.ADDRESS_TYPE] = addressEntryType

        // Build full address string for manual entry
        if (addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL) {
            const fullAddress = buildFullAddressString()
            data[CUSTOMER_FIELDS.BILLING_ADDRESS] = fullAddress
        }

        data[CUSTOMER_FIELDS.SHIPPING_ADDRESS] =
            data[CUSTOMER_FIELDS.BILLING_ADDRESS]

        console.log('data: ', data)

        if (isEditMode && selectedCustomer) {
            // Update existing customer
            data.id = selectedCustomer.id
            updateCustomerHelper(data)
                .then(res => {
                    console.log(res)
                    showAlert('Customer updated successfully!', 'success')
                    getCustomerData()
                    resetDrawerData()
                    handleDrawerToggle()
                })
                .catch(err => {
                    showAlert(err || 'Failed to update customer', 'error')
                })
        } else {
            // Add new customer
            addCustomerHelper(data)
                .then(res => {
                    console.log(res)

                    props.addCustomerAlertAction(true)

                    setTimeout(() => {
                        props.addCustomerAlertAction(false)
                    }, 5000)
                    getCustomerData()
                    resetDrawerData()
                    handleDrawerToggle()
                })
                .catch(() => {})
        }
    }

    const showAlert = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setTimeout(() => {
            setAlertMessage('')
        }, 5000)
    }

    const resetDrawerData = () => {
        setCustomerData({})
        setIsEditMode(false)
        setSelectedCustomer(null)
        // Reset address states
        setAddressEntryType(ADDRESS_ENTRY_TYPE.MANUAL)
        setDistricts([])
        setPoliceStations([])
        setPostOffices([])
    }

    const handleMapSave = (latLng, addressString, placeId, addressComponent) => {
        handleCustomerDetailUpdate(CUSTOMER_FIELDS.BILLING_ADDRESS, addressString)
        setShowMapPopup(false)
    }

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            {addCustomerAlert && (
                <Alert
                    success
                    alertType="success"
                    alertMessage="New Customer added Successfully!"
                />
            )}
            {alertMessage && (
                <Alert
                    success={alertType === 'success'}
                    alertType={alertType}
                    alertMessage={alertMessage}
                />
            )}
            <div className="pageBodyRightPanel">
                {isMobile && (
                    <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
                        <button
                            className="animated zoomIn btn btnPrimary"
                            onClick={handleDrawerToggle}>
                            <AddIcon />
                        </button>
                    </div>
                )}
                {!isMobile && (
                    <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
                        <div className="pageBodyRightPanelHeading">
                            Manage Customers
                        </div>
                        <div className="addProductBtn dFlex aiCenter">
                            {permissions?.features?.[
                                PERMISSION_FEATURE.CUSTOMERS
                            ] === PERMISSION_TYPE.MANAGE && (
                                <button
                                    className="btn btnPrimary"
                                    onClick={handleDrawerToggle}>
                                    ADD
                                </button>
                            )}
                            <div
                                className="pointer ml-4"
                                onClick={() => props.onClose()}>
                                <CloseIcon />
                            </div>
                        </div>
                    </div>
                )}
                <div className="productLlistWrap dFlex">
                    {manageCustomerData &&
                        manageCustomerData.map(customer => {
                            return (
                                <div 
                                    className="cardWrap" 
                                    key={customer.id}
                                    onClick={() => handleCustomerCardClick(customer)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Card
                                        userInitials={convertToTitleCase(
                                            customer?.name?.[0]
                                        )}
                                        headerSup={customer.mobile_no}
                                        headerMain={customer.name}
                                        address={customer.billing_address}
                                        actionIcon={
                                            permissions?.features?.[
                                                PERMISSION_FEATURE.CUSTOMERS
                                            ] === PERMISSION_TYPE.MANAGE && (
                                                <div 
                                                    className="editIconWrap"
                                                    onClick={(e) => handleEditCustomer(customer, e)}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )
                                        }
                                    />
                                </div>
                            )
                        })}
                </div>

                {/* Add/Edit Customer Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleDrawerToggle}
                    open={open}
                    drawerHeading={isEditMode ? "Edit Customer" : "Add Customer"}
                    handleClick={() => handleSubmit()}>
                    <div className="wizardFieldset">
                        <form className="mt-5">
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="custName"
                                    placeholder="Customer Name"
                                    value={customerData?.[CUSTOMER_FIELDS.NAME] || ''}
                                    onChange={e =>
                                        handleCustomerDetailUpdate(
                                            CUSTOMER_FIELDS.NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="custName">Customer Name</label>
                                {isFieldErrorVisible &&
                                    !customerData?.[CUSTOMER_FIELDS.NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter a Customer name.
                                        </div>
                                    )}
                            </div>
                            <div className="formInline dFlex flexNowrap">
                                <div className="formGroup formFloating fgrow1 maxWidth">
                                    <select
                                        className="formSelect"
                                        id="floatingSelect">
                                        <option value="2">+88</option>
                                    </select>
                                    <label htmlFor="floatingSelect">Country</label>
                                    {false && (
                                        <div className="invalidFeedback">
                                            Please choose country code.
                                        </div>
                                    )}
                                </div>
                                <div className="formGroup formFloating ml-4 fgrow1">
                                    <input
                                        type="text"
                                        className="formControl"
                                        id="phone"
                                        placeholder="Phone"
                                        value={
                                            customerData?.[
                                                CUSTOMER_FIELDS.PHONE_NUMBER
                                            ] || ''
                                        }
                                        onChange={e =>
                                            handleCustomerDetailUpdate(
                                                CUSTOMER_FIELDS.PHONE_NUMBER,
                                                e.target.value
                                            )
                                        }
                                        required
                                    />
                                    <label htmlFor="phone">Phone</label>
                                    {isFieldErrorVisible &&
                                        !customerData?.[
                                            CUSTOMER_FIELDS.PHONE_NUMBER
                                        ] && (
                                            <div className="invalidFeedback">
                                                Please select a valid Phone.
                                            </div>
                                        )}
                                </div>
                            </div>
                            {/* Address Entry Toggle */}
                            <div className="addressToggleWrap">
                                <label className="toggleLabel">Address Entry Method</label>
                                <div className="addressToggle">
                                    <button
                                        type="button"
                                        className={`toggleBtn ${addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL ? 'active' : ''}`}
                                        onClick={() => handleAddressEntryTypeChange(ADDRESS_ENTRY_TYPE.MANUAL)}
                                    >
                                        Manual Entry
                                    </button>
                                    <button
                                        type="button"
                                        className={`toggleBtn ${addressEntryType === ADDRESS_ENTRY_TYPE.GOOGLE ? 'active' : ''}`}
                                        onClick={() => handleAddressEntryTypeChange(ADDRESS_ENTRY_TYPE.GOOGLE)}
                                    >
                                        Google Maps
                                    </button>
                                </div>
                            </div>

                            {/* Manual Entry Form */}
                            {addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL && (
                                <div className="manualAddressForm">
                                    <div className="formGroup formFloating">
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="villageHouse"
                                            placeholder="Village/House No."
                                            value={customerData?.[ADDRESS_FIELDS.VILLAGE_HOUSE] || ''}
                                            onChange={e => handleCustomerDetailUpdate(ADDRESS_FIELDS.VILLAGE_HOUSE, e.target.value)}
                                        />
                                        <label htmlFor="villageHouse">Village/House No.</label>
                                    </div>

                                    <div className="formGroup formFloating">
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="roadBlockSector"
                                            placeholder="Road/Block/Sector"
                                            value={customerData?.[ADDRESS_FIELDS.ROAD_BLOCK_SECTOR] || ''}
                                            onChange={e => handleCustomerDetailUpdate(ADDRESS_FIELDS.ROAD_BLOCK_SECTOR, e.target.value)}
                                        />
                                        <label htmlFor="roadBlockSector">Road/Block/Sector</label>
                                    </div>

                                    <div className="formGroup formFloating">
                                        <select
                                            className="formSelect"
                                            id="division"
                                            value={customerData?.[ADDRESS_FIELDS.DIVISION_ID] || ''}
                                            onChange={e => {
                                                const selectedOption = divisions.find(d => d.id === parseInt(e.target.value))
                                                handleDivisionChange(e.target.value, selectedOption?.name || '')
                                            }}
                                        >
                                            <option value="">Select Division</option>
                                            {divisions.map(division => (
                                                <option key={division.id} value={division.id}>
                                                    {division.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="division">Division</label>
                                        {isFieldErrorVisible && !customerData?.[ADDRESS_FIELDS.DIVISION_ID] && (
                                            <div className="invalidFeedback">Please select a Division.</div>
                                        )}
                                    </div>

                                    <div className="formGroup formFloating">
                                        <select
                                            className="formSelect"
                                            id="district"
                                            value={customerData?.[ADDRESS_FIELDS.DISTRICT_ID] || ''}
                                            onChange={e => {
                                                const selectedOption = districts.find(d => d.id === parseInt(e.target.value))
                                                handleDistrictChange(e.target.value, selectedOption?.name || '')
                                            }}
                                            disabled={!customerData?.[ADDRESS_FIELDS.DIVISION_ID] || addressLoading}
                                        >
                                            <option value="">Select District</option>
                                            {districts.map(district => (
                                                <option key={district.id} value={district.id}>
                                                    {district.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="district">District</label>
                                        {isFieldErrorVisible && !customerData?.[ADDRESS_FIELDS.DISTRICT_ID] && (
                                            <div className="invalidFeedback">Please select a District.</div>
                                        )}
                                    </div>

                                    <div className="formGroup formFloating">
                                        <select
                                            className="formSelect"
                                            id="policeStation"
                                            value={customerData?.[ADDRESS_FIELDS.POLICE_STATION_ID] || ''}
                                            onChange={e => {
                                                const selectedOption = policeStations.find(p => p.id === parseInt(e.target.value))
                                                handlePoliceStationChange(e.target.value, selectedOption?.name || '')
                                            }}
                                            disabled={!customerData?.[ADDRESS_FIELDS.DISTRICT_ID] || addressLoading}
                                        >
                                            <option value="">Select Police Station</option>
                                            {policeStations.map(station => (
                                                <option key={station.id} value={station.id}>
                                                    {station.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="policeStation">Police Station</label>
                                        {isFieldErrorVisible && !customerData?.[ADDRESS_FIELDS.POLICE_STATION_ID] && (
                                            <div className="invalidFeedback">Please select a Police Station.</div>
                                        )}
                                    </div>

                                    <div className="formGroup formFloating">
                                        <select
                                            className="formSelect"
                                            id="postOffice"
                                            value={customerData?.[ADDRESS_FIELDS.POST_OFFICE_ID] || ''}
                                            onChange={e => {
                                                const selectedOption = postOffices.find(p => p.id === parseInt(e.target.value))
                                                handlePostOfficeChange(e.target.value, selectedOption?.name || '', selectedOption?.post_code || '')
                                            }}
                                            disabled={!customerData?.[ADDRESS_FIELDS.POLICE_STATION_ID] || addressLoading}
                                        >
                                            <option value="">Select Post Office</option>
                                            {postOffices.map(office => (
                                                <option key={office.id} value={office.id}>
                                                    {office.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="postOffice">Post Office</label>
                                        {isFieldErrorVisible && !customerData?.[ADDRESS_FIELDS.POST_OFFICE_ID] && (
                                            <div className="invalidFeedback">Please select a Post Office.</div>
                                        )}
                                    </div>

                                    <div className="formGroup formFloating">
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="postCode"
                                            placeholder="Post Code"
                                            value={customerData?.[ADDRESS_FIELDS.POST_CODE] || ''}
                                            readOnly
                                        />
                                        <label htmlFor="postCode">Post Code</label>
                                    </div>
                                </div>
                            )}

                            {/* Google Maps Entry */}
                            {addressEntryType === ADDRESS_ENTRY_TYPE.GOOGLE && (
                                <div className="googleMapsAddressForm">
                                    <div className="formGroup formFloating">
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="billing"
                                            placeholder="Address"
                                            value={customerData?.[CUSTOMER_FIELDS.BILLING_ADDRESS] || ''}
                                            onChange={e =>
                                                handleCustomerDetailUpdate(
                                                    CUSTOMER_FIELDS.BILLING_ADDRESS,
                                                    e.target.value
                                                )
                                            }
                                            onClick={() => setShowMapPopup(true)}
                                            readOnly
                                            required
                                        />
                                        <label htmlFor="billing">Address</label>
                                        <div 
                                            className="selectLocationBtn"
                                            onClick={() => setShowMapPopup(true)}
                                        >
                                            Select from Map
                                        </div>
                                        {isFieldErrorVisible &&
                                            !customerData?.[CUSTOMER_FIELDS.BILLING_ADDRESS] && (
                                                <div className="invalidFeedback">
                                                    Please enter a valid Billing Address.
                                                </div>
                                            )}
                                    </div>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="formActionBtnWrap">
                                <button
                                    type="button"
                                    className="btn btnSecondary"
                                    onClick={addressEntryType === ADDRESS_ENTRY_TYPE.MANUAL ? clearManualAddressFields : clearGoogleMapsAddress}
                                >
                                    Clear
                                </button>
                                <button
                                    type="button"
                                    className="btn btnPrimary"
                                    onClick={() => handleSubmit()}
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </SideDrawer>

                {/* Map Popup */}
                {showMapPopup && (
                    <div className="mapPopupOverlay">
                        <div className="mapPopupContainer">
                            <div className="mapPopupHeader">
                                <h3>Select Address</h3>
                                <div 
                                    className="closeMapBtn"
                                    onClick={() => setShowMapPopup(false)}
                                >
                                    <CloseIcon />
                                </div>
                            </div>
                            <CustomMap 
                                onClose={() => setShowMapPopup(false)}
                                onSave={handleMapSave}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        alert: state.alertReducer.alert,
        loginData: state.loginDataReducer?.loginData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addCustomerAlertAction: payload =>
            dispatch(addCustomerAlertAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCustomer)
